import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isAssignManagerToResourceRequestFailure({ uuid }) {
      const state = getState().find(({ resource }) => uuid === resource.uuid);

      return state ? state.request.isFailure : false;
    },
    isAssignManagerToResourceRequestPending({ uuid }) {
      const state = getState().find(({ resource }) => uuid === resource.uuid);

      return state ? state.request.isPending : false;
    },
    isAssignManagerToResourceRequestSuccess({ uuid }) {
      const state = getState().find(({ resource }) => uuid === resource.uuid);

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
